import FileTypeIcon from '@/components/FileTypeIcon'
import { Image } from '@/components/ui/image'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import { UploadFileAsset } from '@/lib/api/qiniuApi'
import { cn } from '@/lib/cn'
import setImageUrlResizeParams from '@/lib/utils/imageUrlResizeParams'
import { Attachment } from '@/typings/domain'
import { XIcon } from 'lucide-react-native'
import { useMemo } from 'react'
import { Pressable, View } from 'react-native'

type AttachmentItemProps = {
  className?: string
  attachment?: Attachment
  uploadFileAsset?: UploadFileAsset
  uploadProgress?: number
  size?: 'lg' | 'sm'
  showFileName?: boolean
  onRemove?: () => void
}

export default function AttachmentItem({
  className,
  attachment,
  uploadFileAsset,
  uploadProgress,
  size,
  showFileName,
  onRemove,
}: AttachmentItemProps) {
  const contentType = attachment?.contentType ?? uploadFileAsset?.mimeType
  const fileName = attachment?.fileName ?? (uploadFileAsset?.fileName || uploadFileAsset?.name)

  const resizedVisitUrl = useMemo(
    () => (attachment?.visitUrl ? setImageUrlResizeParams(attachment.visitUrl, { w: 100 }) : null),
    [attachment?.visitUrl]
  )

  return (
    <VStack
      className={cn('relative rounded-lg items-center', size === 'lg' ? 'w-[80px]' : 'w-[40px]', className)}
      space="xs"
    >
      <View className={cn('overflow-hidden aspect-square rounded-lg', size === 'lg' ? 'w-[80px]' : 'w-[40px]')}>
        {contentType?.startsWith('image/') ? (
          <Image
            className="w-full h-full"
            source={resizedVisitUrl ? { uri: resizedVisitUrl } : uploadFileAsset}
            alt={fileName ?? ''}
          />
        ) : (
          <FileTypeIcon fileName={fileName ?? ''} size={size === 'lg' ? 80 : 40} />
        )}
        {typeof uploadProgress === 'number' && (
          <View
            className="absolute top-0 right-0 h-full bg-[#00000080]"
            style={{ width: `${100 - uploadProgress}%` }}
          />
        )}
      </View>
      {showFileName ? (
        <Text className="w-full text-xs text-typography-900 text-center" isTruncated>
          {fileName}
          {fileName}
          {fileName}
          {fileName}
        </Text>
      ) : null}
      {onRemove ? (
        <Pressable className="absolute -top-2 -right-2 bg-[#00000080] rounded-full" onPress={onRemove}>
          <XIcon size={14} color="#ffffff" />
        </Pressable>
      ) : null}
    </VStack>
  )
}
